import { inject } from 'tsyringe'
import { containerScoped } from '~/decorators/dependency-container'
import { CategoryChooserResult } from '~/models/category/chooser'
import RequestBuilder from '~/builders/http/RequestBuilder'
import { formatCategoryChooserResult } from '~/services/category/formatters'

@containerScoped()
export default class CategoryChooserService {
  constructor(@inject(RequestBuilder) private requestBuilder: RequestBuilder) {}

  getClassifiedCreateIndexCategories(): Promise<CategoryChooserResult> {
    return this.requestBuilder
      .request('get', '/api/classifieds/categories/new/')
      .map(formatCategoryChooserResult)
      .send()
  }
}
